<template>
  <div class="attendant-instruction__wrapper">
    <h2 class="attendant-instruction__title">
      Peça para o paciente entrar no check-in e clicar no botão de confirmar chegada
    </h2>
    <p class="attendant-instruction__subtitle">
      Assim o paciente pula a etapa de atendimento na recepção e vai direto para a sala de espera do exame.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AttendantInstruction'
};
</script>

<style lang="scss" scoped>
.attendant-instruction{
  &__wrapper{
    background-color: #002FDB;
    margin-top: $gap-default;
    padding: $gap-cozy $gap-default;
    border-radius: $border-radius;
    position: relative;
  }

  &__title{
    color: #FEFEFE;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    padding-bottom: $gap-default;
  }

  &__subtitle{
    color: #FEFEFE;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }
}

</style>
